const planning = [
  {
    path: '/planning/deliveries',
    name: 'Deliveries',
    component: () => import(/* webpackChunkName: "planningPage" */ '@/components/modules/planning/Deliveries'), // Deliveries,
    meta: {
      title: 'Planning',
      requiresAuth: true,
    },
  },
  {
    path: '/planning/requests',
    name: 'ReturnRequest',
    component: () => import(/* webpackChunkName: "planningPage" */ '@/components/modules/planning/ReturnRequest'), // Return Request,
    meta: {
      title: 'Planning',
      requiresAuth: true,
    },
  },
  {
    path: '/planning/create',
    name: 'RequestDetails',
    component: () => import(/* webpackChunkName: "planningPage" */ '@/components/modules/planning/RequestDetails'), // Create Request,
    meta: {
      title: 'Planning',
      requiresAuth: true,
    },
  },
  {
    path: '/planning/:requestNo',
    name: 'RequestDetails',
    props: true,
    component: () => import(/* webpackChunkName: "planningPage" */ '@/components/modules/planning/RequestDetails'), // Edit Request,
    meta: {
      title: 'Planning',
      requiresAuth: true,
    },
  },
];

export default planning;

